import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Layout components
import MainLayout from './components/layout/MainLayout';

// Auth components
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import VerificationPending from './components/auth/VerificationPending';
import VerifyEmail from './components/auth/VerifyEmail';

// Protected route component
import ProtectedRoute from './components/common/ProtectedRoute';

// Dashboard component
import Dashboard from './components/dashboard/Dashboard';

// Project components
import ProjectsList from './components/projects/ProjectsList';
import CreateProject from './components/projects/CreateProject';
import EditProject from './components/projects/EditProject';
import ProjectDetail from './components/projects/ProjectDetail';

// Document components
import UploadDocument from './components/documents/UploadDocument';
import DocumentDetail from './components/documents/DocumentDetail';
import ChatWithDocument from './components/documents/ChatWithDocument';

// Profile component
import UserProfile from './components/profile/UserProfile';

// Test components
import ApiTest from './components/test/ApiTest';
import LoginTest from './components/test/LoginTest';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verification-pending" element={<VerificationPending />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/api-test" element={<ApiTest />} />
          <Route path="/login-test" element={<LoginTest />} />
          
          {/* Protected routes with layout */}
          <Route element={<MainLayout />}>
            {/* Redirect root to dashboard if authenticated, otherwise to login */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              
              {/* Project routes */}
              <Route path="/projects" element={<ProjectsList />} />
              <Route path="/projects/create" element={<CreateProject />} />
              <Route path="/projects/edit/:id" element={<EditProject />} />
              <Route path="/projects/:projectId" element={<ProjectDetail />} />
              
              {/* Document routes */}
              <Route path="/documents/upload" element={<UploadDocument />} />
              <Route path="/documents/:documentId" element={<DocumentDetail />} />
              <Route path="/documents/:documentId/chat" element={<ChatWithDocument />} />
              
              {/* Profile route */}
              <Route path="/profile" element={<UserProfile />} />
            </Route>
          </Route>
          
          {/* Catch all route - redirect to dashboard or login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
